export default function LoadingTableItems() {
    return (
        <>
            <div className="mt-8 animate-pulse space-y-2">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="h-10 rounded bg-gray-100"/>
                ))}
            </div>
        </>
    );
}